import { user } from 'src/StateObserver';
import { ChampionsLeagueUserProperties } from 'src/replicant/championsLeague/championsLeague.analytics.schema';
import {
  getCurrentLeagueId,
  getEndedLeagues,
  getLeagueScore,
  getUnclaimedLeagues,
  hasJoinedLeague,
} from 'src/replicant/match2/leagues/leagues.getters';
import { isArenaAvailable } from 'src/replicant/championsLeague/championsLeague.getters';
import { ImageScaleView, MovieClip } from '@play-co/timestep-core/ui';
import { getLeagueLeaderboard } from '../minigame/match2-timestep/leagues/league.sequences';

/**
 * Retrieve the Champions League user properties
 * @param state
 * @returns
 */
export function getChampionsLeagueUserProperties(): ChampionsLeagueUserProperties {
  // If the user has not joined the league, return an empty object
  if (!hasJoinedLeague(user())) {
    return {};
  }

  // Check cached data which contains the player rank
  const data = getLeagueLeaderboard().getCached();

  return {
    lastExitChampionsRank: data ? data.playerRank : undefined,
    lastExitChampionsMedals: getLeagueScore(user()) ?? 0,
  };
}

/**
 * Get the ID of the league that should be prioritized for the user.
 * This can be the unclaimed league, if available - or the currently active league.
 */
export function getPrioritizedLeagueId() {
  const unclaimedLeagues = [
    ...getEndedLeagues(user()),
    ...getUnclaimedLeagues(user()),
  ];
  return unclaimedLeagues.length
    ? unclaimedLeagues[0]
    : getCurrentLeagueId(user());
}

export function attachCrownToPet(clip: MovieClip) {
  // Only if user is playing champions league
  if (!isArenaAvailable(user())) return;
  clip.addViewSubstitution(
    'placeholder_hat',
    new ImageScaleView({
      image: 'assets/ui/championsLeague/crown.png',
      width: 160,
      height: 160,
      centerOnOrigin: true,
    }),
  );
}
